import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import axios from "axios";
import { baseUrl, mainBaseUrl } from "../../App";
import loaderimg from "../../Images/Infinity-1s-200px.gif";

const UploadCSV = ({ getInfo }) => {
  const [file, setFile] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [loads, setLoads] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const uploadCSV = (e) => {
    setLoads(true);
    var formData = new FormData();
    formData.append("certificatesData", file);
    axios
      .post(`${mainBaseUrl}/publishCertificates`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
          "API-Key": baseUrl,
        },
      })
      .then(setLoads(false))
      .then(handleClose)
      // .then(() => window.location.reload())
      .then(() => getInfo())
      .catch((e) => alert(e.response.statusText))
      .catch(setLoads(false));
  };

  return (
    <div>
      <button onClick={handleClickOpen}>Upload CSV</button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Upload Certificate CSV</DialogTitle>

        <DialogContent>
          <TextField
            margin="dense"
            id="name"
            type="file"
            variant="outlined"
            onChange={(e) => setFile(e.target.files[0])}
            fullWidth
          />
          <Button
            onClick={uploadCSV}
            variant="contained"
            style={{
              backgroundColor: "#200e32",
              color: "white",
            }}
          >
            Upload CSV
          </Button>
        </DialogContent>
        {/* )} */}
        <DialogActions>
          <Button color="primary">
            {loads ? (
              <div
                style={{ height: "5rem", overflow: "hidden" }}
                className="imgContainer"
              >
                <img className="gif" src={loaderimg} alt="" />
              </div>
            ) : (
              ""
            )}
          </Button>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UploadCSV;
